/* eslint-disable spire/export-styles */
import translate from "@insite/client-framework/Translate";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import WarehouseModalLocationHours from "@WhiteCap/Icons/WarehouseModalLocationHours";
import * as React from "react";

type WarehouseHoursLinkProps = LinkPresentationProps & {
    warehouse: WarehouseModel;
    onOpenWarehouseHours: (warehouse: WarehouseModel) => void;
    iconMode?: boolean;
    iconStyleProps?: IconPresentationProps;
};

const WarehouseHoursLink: React.FC<WarehouseHoursLinkProps> = ({ warehouse, iconMode, iconStyleProps, onOpenWarehouseHours, ...otherProps }) => {
    if (!warehouse.hours) {
        return null;
    }
    const handleHoursClicked = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        onOpenWarehouseHours(warehouse);
    };
    return (
        iconMode ?
            <Icon {...iconStyleProps}
                src={WarehouseModalLocationHours}
                onClick={handleHoursClicked}
            >
            </Icon> :
            <Link onClick={handleHoursClicked} {...otherProps}>
                {translate("Hours")}
            </Link >
    );
};

export default WarehouseHoursLink;
